export default __webpack_public_path__ + "static/bolivar-b40474a8c81cf01f953d440297278e17.jpeg";